import React, { useEffect } from 'react'
import Header from '../Common/Header'
import Footer from '../Common/Footer'
import HeroSection from './HeroSection'
import FeaturesSection from './FeaturesSection'
import DownloadSection from './DownloadSection'
import WealthSection from "./WealthSection"
import RewardsSection from "./RewardsSection"
import CommunitySection from "./CommunitySection"
import './motion.css'
import './wallet-theme.css'
function Layout() {
  useEffect(() => {
    const sections = document.querySelectorAll('.motion-section')

    sections.forEach((section) => section.classList.add('motion-ready'))

    if (!('IntersectionObserver' in window)) {
      sections.forEach((section) => section.classList.add('is-visible'))
      return undefined
    }

    const observer = new IntersectionObserver((entries, currentObserver) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return

        entry.target.classList.add('is-visible')
        currentObserver.unobserve(entry.target)
      })
    }, { threshold: 0.12 })

    sections.forEach((section) => observer.observe(section))

    return () => observer.disconnect()
  }, [])

  return (
    <div>
      <Header />
      <HeroSection/>
      <WealthSection/>
      <RewardsSection/>
      <CommunitySection/>
      <FeaturesSection/>
      <DownloadSection/>
      <Footer />
    </div>
  )
}

export default Layout